// src/notifications/notificationsApi.ts
import { apiClient } from "@maat/api-base";
var notificationsApi = {
  getNotifications: async (page = 1, pageSize = 20) => {
    return apiClient.get("/notifications/api/notifications", { params: { page, pageSize } });
  },
  getUnreadCount: async () => {
    return apiClient.get("/notifications/api/notifications/unread-count");
  },
  /** Relative on purpose: web EventSource resolves against the origin, and
   *  the native SSE adapter resolves against its configured API base URL. */
  getSSEUrl: () => "/notifications/api/sse",
  markActioned: async (id) => {
    return apiClient.patch(`/notifications/api/notifications/${id}/actioned`);
  },
  markRead: async (id) => {
    return apiClient.patch(`/notifications/api/notifications/${id}/read`);
  },
  markAllRead: async () => {
    return apiClient.patch("/notifications/api/notifications/read-all");
  },
  registerPushToken: async (payload) => {
    return apiClient.post("/notifications/api/push-tokens", payload);
  },
  removePushToken: async (token) => {
    return apiClient.delete(`/notifications/api/push-tokens/${encodeURIComponent(token)}`);
  },
  getNotificationSettings: async () => {
    return apiClient.get("/notifications/api/notification-settings");
  },
  getNotificationPreferenceGroups: async () => {
    return apiClient.get("/notifications/api/notification-settings/templates");
  },
  updateNotificationSettings: async (payload) => {
    return apiClient.patch("/notifications/api/notification-settings", payload);
  }
};

export {
  notificationsApi
};
